<template>
  <!-- eslint-disable -->
  <main>
    <div class="flex flex-wrap">
      <div class="m-6 flex flex-wrap gap-5">
        <SmButton @click="loadAll">Load all</SmButton>
        <SmButton @click="getAllAccountsTheOldWay">Load all accounts</SmButton>
        <SmButton @click="storeAllToCache">Store all to cache</SmButton>
        <SmButton type="danger" @click="deleteAll">
          Delete and Recreate Cache
        </SmButton>
        <SmButton type="danger" @click="deleteTable">Delete Table</SmButton>

        <SmButton @click="getAll">Load all Cache</SmButton>
        <SmButton @click="logSqliteInfo">Log SQLite Info</SmButton>
      </div>
      <div class="m-6 flex flex-row gap-4">
        <div class="flex flex-col">
          <span>Accounts</span>
          <span>{{ allAccounts.length }}</span>
        </div>

        <div class="flex flex-col">
          <span>Accounts (Chache)</span>
          <span>{{ allAccountsSQL.length }}</span>
        </div>
      </div>

      <div class="m-5 flex h-fit min-w-96 flex-col gap-3 rounded border p-3">
        <h1>Test Filter</h1>
        <SmInput v-model="query" size="small" outline />

        <div class="flex align-middle">
          <span class="min-w-24">Limit</span>
          <SmInput v-model="limitString" size="small" outline type="number" />
        </div>

        <div>
          <span>Results: </span>
          <span class="font-bold">{{ searchResults.length }}</span>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
  import { LicenceOut, UserLicencesService } from '@/client'
  import { useFetch } from '@/composables/useFetch'
  import SmButton from '@/components/sm/SmButton.vue'
  import SmInput from '@/components/sm/SmInput.vue'
  import { AccountStore } from '@/stores/account/account.store'
  import { db, resetDatabase } from '@/stores/database'
  import { sql } from 'kysely'

  async function loadAll() {
    await db.selectFrom('licence_out').selectAll().execute()
  }

  const allAccounts = ref<LicenceOut[]>([])
  async function getAllAccountsTheOldWay() {
    const { data, error, fetchData, loading } = useFetch(
      () => UserLicencesService.getLicencesApiV1SoftwareLicencesGet({}),
      null,
      { sendToast: true }
    )
    return fetchData().then(() => {
      if (data.value) allAccounts.value = data.value
      return { data: data.value, error: error.value, loading: loading.value }
    })
  }

  async function storeAllToCache() {
    const rawAccounts = toRaw(allAccounts.value)
    await AccountStore.bulkInsertLicenceOuts(rawAccounts)
  }

  const allAccountsSQL = ref<LicenceOut[]>([])
  async function getAll() {
    allAccountsSQL.value = await AccountStore.getAllLicenceOuts()
  }

  // Query
  const query = ref<string>()
  const limit = ref<number>(1000)
  const searchResults = ref<LicenceOut[]>([])
  watch(
    [query, limit],
    async () => {
      searchResults.value = await AccountStore.getAccounts(
        { email: query.value },
        { limit: limit.value !== 0 ? limit.value || undefined : undefined }
      )
    },
    { immediate: true }
  )

  const limitString = computed(() => {
    return String(limit.value)
  })

  // Delete Table
  async function deleteTable() {
    db.schema.dropTable('licence_out').ifExists().execute()
  }

  async function deleteAll() {
    resetDatabase()
  }

  async function logSqliteInfo() {
    const compileResult = await sql`PRAGMA compile_options;`.execute(db)
    const options = compileResult.rows
      .map((row) => Object.values(row)[0])
      .filter((value): value is string => typeof value === 'string')
    const maxVariable = options.find((option) =>
      option.startsWith('MAX_VARIABLE_NUMBER=')
    )

    const sourceResult =
      await sql`SELECT sqlite_source_id() AS source_id;`.execute(db)
    const sourceId = sourceResult.rows[0]
      ? ((sourceResult.rows[0] as { source_id?: string }).source_id ?? null)
      : null

    console.warn('[TestView] SQLite compile info', {
      maxVariable,
      sourceId,
      options,
    })
  }
</script>
